module.exports = __webpack_public_path__ + "img/q10.8a98c02c.png";